<template>
    <ModalComponent
        :name="name"
        :title="title"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <h2>{{borrarTitle}}</h2>
            </div>
            <div class="col-12">
                <slot></slot>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">{{confirmButton}}</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="confirm">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            name: String,
            title: String,
            borrarTitle: String,
            confirmButton: String
        },
        methods: {
            close() {
                this.$emit('close');
            },
            confirm() {
                this.$emit('confirm');
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
